"use client";

import type { FC } from "react";

import { clsx } from "clsx";
import dynamic from "next/dynamic";

const ProductDemo = dynamic(() => import("@ui/components/demos/TTS/components/ProductDemo"));

export interface TextToSpeechDemoProps {
  defaultText?: string;
  className?: string;
}

const TextToSpeechDemo: FC<TextToSpeechDemoProps> = ({ defaultText, className }) => {
  return (
    <div
      className={clsx(
        "tw-h-[70%] md:tw-h-[60%] tw-mb-6 tw-w-full tw-flex tw-items-center tw-justify-center",
        className,
      )}
    >
      <div className='tw-h-full tw-w-auto tw-aspect-[2/1] tw-max-w-full'>
        <ProductDemo defaultText={defaultText} useChevronButton />
      </div>
    </div>
  );
};

export default TextToSpeechDemo;
